import React from 'react'
import yn from 'yn'

import BkFlowRoomCardRateStagePriceButton from './BkFlowRoomCardRateStagePriceButton'

if (yn(process.env.REACT_APP_COMPONENT_ENABLE_PARENT_CHILD_RATE_SORTING)) {
	require('../../../../styles/css/components/room/bk-flow-room-cards-price-collection.css')
}

const BkFlowRoomCardRateStagePriceCollection = props => {
	const {
		activeCurrencyData,
		childRatePlanData,
		childRoomRateData,
		currentRateCode,
		currentUpSells,
		ratePlanData,
		roomGroup,
		roomRateData,
		toggleActiveRoom,
		totalNights,
		upSellsToggleEvent
	} = props

	let ratePlanName = null

	// Set rate plan name
	if (
		ratePlanData &&
		ratePlanData.ratePlanName
	) {
		ratePlanName = ratePlanData.ratePlanName
	}

	return (
		<div className="bk-flow-room__price-collection">
			{ ratePlanName && <p className="bk-flow-room__price-title u-remove-margin">{ ratePlanName }</p> }

			{ roomRateData &&
				ratePlanData &&
				<BkFlowRoomCardRateStagePriceButton
					key={ roomRateData.ratePlanCode }
					activeCurrencyData={activeCurrencyData}
					currentRateCode={currentRateCode}
					currentUpSells={currentUpSells}
					totalNights={totalNights}
					roomGroup={roomGroup}
					roomRateData={roomRateData}
					ratePlanData={ratePlanData}
					toggleActiveRoom={toggleActiveRoom}
					isCollectionRate={true}
					upSellsToggleEvent={(roomTypeCode, roomRateCode) => upSellsToggleEvent(roomTypeCode, roomRateCode)}
				/>
			}

			{ childRoomRateData &&
				childRatePlanData &&
				<BkFlowRoomCardRateStagePriceButton
					key={ childRoomRateData.ratePlanCode }
					activeCurrencyData={activeCurrencyData}
					currentRateCode={currentRateCode}
					currentUpSells={currentUpSells}
					totalNights={totalNights}
					roomGroup={roomGroup}
					roomRateData={childRoomRateData}
					ratePlanData={childRatePlanData}
					toggleActiveRoom={toggleActiveRoom}
					isCollectionRate={true}
					upSellsToggleEvent={(roomTypeCode, roomRateCode) => upSellsToggleEvent(roomTypeCode, roomRateCode)}
				/>
			}
		</div>
	)
}

export default BkFlowRoomCardRateStagePriceCollection



// WEBPACK FOOTER //
// ./src/components/room/elements/multi-stage/BkFlowRoomCardRateStagePriceCollection.js